export default __webpack_public_path__ + "static/media/photobooths1.1c0ecadd.jpg";